<template>
    <div>
        <hr v-if="model.specifyInstitution" />

        <div class="row">
            <div class="form-group col-sm-12 col-md-8" v-if="model.specifyInstitution === false">
                <label class="font-weight-bold"
                       :class="isRequired ? 'required' : ''"
                       :for="'institution' + _uid">{{ $t('person.institution') }}</label>
                <dynamic-dropdown :apiUrl="`/api/institution/dropdownModel/false`"
                                  v-model="model.institutionRegisterId"
                                  :id="'institution' + _uid"
                                  :name="'institution' + _uid"
                                  :required="isRequired"
                                  :fieldName="$t('person.institution')"
                                  :filter="'contains'"
                                  :clear-button="true"
                                  :autoWidth="true"
                                  :height="400"
                                  :disabled="disabled"
                                  aria-describedby="institutionHelpBlock"></dynamic-dropdown>
                <small id="institutionHelpBlock" class="form-text text-muted">{{ $t('person.help.institutionHelp') }}</small>
            </div>
            <div class="form-group col-sm-12 col-md-4">
                <vs-checkbox v-model="model.specifyInstitution"
                             :name="'specifyInstitution' + _uid"
                             :id="'specifyInstitution' + _uid"
                             :disabled="disabled"
                             style="justify-content: flex-start !important">
                    {{ $t('person.specifyInstitution') }}
                </vs-checkbox>
            </div>
        </div>

        <div class="row" v-if="model.specifyInstitution">
            <div class="form-group col-sm-12 col-md-4">
                <label class="font-weight-bold"
                       :class="isRequired ? 'required' : ''"
                       :for="'institutionOther' + _uid">{{ $t('person.institution') }}</label>
                <input type="text" class="form-control"
                       v-model="model.institutionOther"
                       v-validate="isRequired ? 'required' : ''"
                       :data-vv-as="$t('person.institution')"
                       :id="'institutionOther' + _uid"
                       :name="'institutionOther' + _uid"
                       :readonly="disabled"/>
                <span class="text-danger col-12" v-if="errors.has('institutionOther' + _uid)">{{ errors.first('institutionOther' + _uid) }}</span>
            </div>
            <div class="form-group col-sm-12 col-md-4">
                <label class="font-weight-bold" :for="'institutionOtherCountryId' + _uid">{{ $t('person.country') }}</label>
                <DropdownSearch ref="countryDropdown"
                                :loadByParentSort="true"
                                :parentSort="countrySort"
                                :id="'institutionOtherCountryId' + _uid"
                                v-model="model.institutionOtherCountryId"
                                :name="'institutionOtherCountryId' + _uid"
                                :disabled="disabled">
                </DropdownSearch>
            </div>
            <div class="form-group col-sm-12 col-md-4">
                <label class="font-weight-bold" :for="'institutionOtherCity' + _uid">{{ $t('person.settlement') }}</label>
                <div v-if="model.institutionOtherCountryId == countries.BG">
                    <CityDropdownSearch ref="settlementDropdown"
                                        :id="'settlement' + _uid"
                                        v-model="model.institutionOtherCityId"
                                        :name="'institutionOtherCityId' + _uid"
                                        :disabled="disabled"
                                        @input="cityChanged">
                    </CityDropdownSearch>
                </div>
                <div v-else>
                    <input type="text"
                           class="form-control"
                           v-model="model.institutionOtherCity"
                           :id="'institutionOtherCity' + _uid"
                           :readonly="disabled"/>
                </div>
            </div>
        </div>

        <hr v-if="model.specifyInstitution" />
    </div>
</template>

<script>
    import { Person, AreaOfAppeal } from '../../models/models';
    import DynamicDropdown from '../dropdown/DynamicDropdown';
    import DropdownSearch from '../dropdown/DropdownSearch';
    import CityDropdownSearch from '../dropdown/CityDropdownSearch';
    import { NomenclatureParentBySort, Countries, Cities } from '../../models/enums';

    export default {
        props: {
            value: {
                type: [Person, Object],
                required: true
            },
            disabled: {
                type: Boolean,
                required: false
            },
            isRequired: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        components: {
            DynamicDropdown,
            DropdownSearch,
            CityDropdownSearch
        },
        data() {
            return {
                model: this.value,
                countries: Countries,
                cities: Cities,
                countrySort: NomenclatureParentBySort.Countries
            }
        },
        methods: {
            cityChanged() {
                this.$http
                    .get(
                        '/api/cities/getAreaOfAppeal/' +
                        `${this.model.institutionOtherCityId}`
                    )
                    .then(response => {
                        this.model.areaOfAppeal = new AreaOfAppeal(
                            response.data.areaOfAppeal
                        );
                    })
                    .catch(error => {

                    });
            }
        },
        watch: {
            value: function (val) {
                if (val) {
                    this.model = this.value;
                }
            },
            'model.institutionOtherCountryId': function (newVal, oldVal) {
                if (newVal === this.countries.BG) {
                    this.model.institutionOtherCity = '';
                }
            },
            'model.specifyInstitution': function (newVal, oldVal) {
                if (newVal === false) {
                    this.model.institutionOther = '';
                    this.model.institutionOtherCountryId = this.countries.BG;
                    this.model.institutionOtherCityId = this.cities.Sofia;
                } else {
                    this.model.institutionRegisterId = '';
                }
            }
        }
    }
</script>
